module.exports = __webpack_public_path__ + "static/media/7.7264ecf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/7.png
// module id = 484
// module chunks = 0